export var VERSION = '2.16.1';
//# sourceMappingURL=version.js.map